import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { share } from 'rxjs/operators';
import { ApplicationConfig } from '../../config/config';

declare let delta: any;

@Injectable({
  providedIn: 'root'
})
export class MDotService {
  constructor(
    private _http: HttpClient,
    private config: ApplicationConfig,
    private datePipe: DatePipe
  ) {}

  getCompressedResponse(jsonPayload) {
    const body = JSON.stringify(jsonPayload);
    const customheaders = new HttpHeaders({ 'Content-Type': 'text/plain' });
    return this._http
      .post(`${this.config.get('APP_UTIL_MOBILE_COMPRESS_URL')}`, body, {
        headers: customheaders,
        responseType: 'text'
      })
      .pipe(share());
  }

  getValue(cond1, val1, val2) {
    if (cond1.schedulePrice && cond1.schedulePrice === 'miles') {
      return val1;
    }
    return val2;
  }

  getPayloadForOneWayAppEnableApp(formValue, mkcpgn) {
    return {
      constraints: formValue.refundableFlightsOnly ? ['refundable'] : [],
      version: '2',
      segments: [
        {
          departureDate: this.datePipe.transform(
            new Date(formValue.dates.departureDate),
            'yyyy-MM-dd'
          ),
          origin: formValue.airports.fromAirportcode,
          destination: formValue.airports.toAirportcode
        }
      ],
      tripType: formValue.selectTripType,
      marketingCampaign: mkcpgn,
      passenger: {
        adultCount: formValue.passenger
      },
      priceType: this.getValue(formValue, 'Award', 'Revenue'),
      cabin: formValue.faresFor,
      eventCode: formValue.meetingEventCode,
      sortBy: this.getValue(formValue, 'deltaBestMatch', 'customScore')
    };
  }

  getPayloadForOneWayAppDisabledApp(formValue, mkcpgn) {
    return {
      constraints: formValue.refundableFlightsOnly ? ['refundable'] : [],
      version: '2',
      slices: [
        {
          date: this.datePipe.transform(
            new Date(formValue.dates.departureDate),
            'yyyy-MM-dd'
          ),
          origin: formValue.airports.fromAirportcode,
          destination: formValue.airports.toAirportcode,
          sort: this.getValue(formValue, 'deltaBestMatch', 'customScore')
        }
      ],
      type: formValue.selectTripType,
      marketingCampaign: mkcpgn,
      pax: formValue.passenger,
      shopType: this.getValue(formValue, 'Award', 'Revenue'),
      cabin: formValue.faresFor,
      eventCode: formValue.meetingEventCode
    };
  }

  getBookPayloadForOneWay(formValue, mkcpgn?: string) {
    if (this.config.get('APP_ENABLE_MOBILE_SL') === 'true') {
      return this.getPayloadForOneWayAppEnableApp(formValue, mkcpgn);
    }
    return this.getPayloadForOneWayAppDisabledApp(formValue, mkcpgn);
  }

  getBookPayloadAppEnableMobile(formValue, mkcpgn) {
    return {
      constraints: formValue.refundableFlightsOnly ? ['refundable'] : [],
      version: '2',
      segments: [
        {
          departureDate: this.datePipe.transform(
            new Date(formValue.dates.departureDate),
            'yyyy-MM-dd'
          ),
          origin: formValue.airports.fromAirportcode,
          destination: formValue.airports.toAirportcode
        },
        {
          departureDate: this.datePipe.transform(
            new Date(formValue.dates.returnDate),
            'yyyy-MM-dd'
          ),
          origin: formValue.airports.toAirportcode,
          destination: formValue.airports.fromAirportcode
        }
      ],
      tripType: formValue.selectTripType,
      marketingCampaign: mkcpgn,
      passenger: {
        adultCount: formValue.passenger
      },
      priceType:
        formValue.schedulePrice && formValue.schedulePrice === 'miles'
          ? 'Award'
          : 'Revenue',
      cabin: formValue.faresFor,
      eventCode: formValue.meetingEventCode,
      sortBy: 'customScore'
    };
  }

  getBookPayloadAppDisableMobile(formValue, mkcpgn) {
    return {
      constraints: formValue.refundableFlightsOnly ? ['refundable'] : [],
      version: '2',
      slices: [
        {
          date: this.datePipe.transform(
            new Date(formValue.dates.departureDate),
            'yyyy-MM-dd'
          ),
          origin: formValue.airports.fromAirportcode,
          destination: formValue.airports.toAirportcode,
          sort: 'customScore'
        },
        {
          date: this.datePipe.transform(
            new Date(formValue.dates.returnDate),
            'yyyy-MM-dd'
          ),
          origin: formValue.airports.toAirportcode,
          destination: formValue.airports.fromAirportcode,
          sort: 'customScore'
        }
      ],
      type: formValue.selectTripType,
      marketingCampaign: mkcpgn,
      pax: formValue.passenger,
      shopType:
        formValue.schedulePrice && formValue.schedulePrice === 'miles'
          ? 'Award'
          : 'Revenue',
      cabin: formValue.faresFor,
      eventCode: formValue.meetingEventCode
    };
  }

  getBookPayloadForRoundTrip(formValue, mkcpgn?: string) {
    if (this.config.get('APP_ENABLE_MOBILE_SL') === 'true') {
      return this.getBookPayloadAppEnableMobile(formValue, mkcpgn);
    }
    return this.getBookPayloadAppDisableMobile(formValue, mkcpgn);
  }

  appEnableMobConf(formValue, mkcpgn) {
    const slices = [];
    formValue.flights.map((flight) => {
      slices.push({
        departureDate: this.datePipe.transform(
          new Date(flight.departureDate),
          'yyyy-MM-dd'
        ),
        origin: flight.airports.fromAirportcode,
        destination: flight.airports.toAirportcode
      });
    });
    return {
      constraints: ['refundable'],
      version: '2',
      segments: slices,
      tripType: formValue.selectTripType,
      marketingCampaign: mkcpgn,
      passenger: {
        adultCount: formValue.passenger
      },
      priceType:
        formValue.schedulePrice && formValue.schedulePrice === 'miles'
          ? 'Award'
          : 'Revenue',
      cabin: formValue.faresFor,
      eventCode: formValue.meetingEventCode,
      sortBy: 'deltaBestMatch'
    };
  }

  appDisableMobConf(formValue, mkcpgn) {
    const slices = [];
    formValue.flights.map((flight) => {
      slices.push({
        date: this.datePipe.transform(
          new Date(flight.departureDate),
          'yyyy-MM-dd'
        ),
        origin: flight.airports.fromAirportcode,
        destination: flight.airports.toAirportcode,
        sort: 'deltaBestMatch'
      });
    });
    return {
      constraints: ['refundable'],
      version: '2',
      slices: slices,
      type: formValue.selectTripType,
      marketingCampaign: mkcpgn,
      pax: formValue.passenger,
      shopType:
        formValue.schedulePrice && formValue.schedulePrice === 'miles'
          ? 'Award'
          : 'Revenue',
      cabin: formValue.faresFor,
      eventCode: formValue.meetingEventCode
    };
  }

  getBookPayloadForMulticity(formValue, mkcpgn?: string) {
    // let slices = [];
    if (this.config.get('APP_ENABLE_MOBILE_SL') === 'true') {
      return this.appEnableMobConf(formValue, mkcpgn);
    }
    return this.appDisableMobConf(formValue, mkcpgn);
  }
}
